// extracted by mini-css-extract-plugin
export default {"slot":"mobile-preview-toggle_slot__aO-0w","toggle":"mobile-preview-toggle_toggle__8nH+g"};